import { NgModule } from '@angular/core';
import { CompanyComponent } from './company/company.component';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core/core.module';
import { FormsModule } from '@angular/forms';
import { CompanyEditComponent } from './company-edit/company-edit.component';

@NgModule({
  declarations: [
    CompanyComponent,
    CompanyEditComponent
  ],
  imports: [
    CommonModule,
    CoreModule,
    FormsModule
  ]
})
export class CompaniesModule {}
